import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import * as firebase from 'firebase';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {

  signInForm: FormGroup;
  errorMessage: string; 
  actif: boolean
  captcha:boolean

  constructor(private formBuilder: FormBuilder, 
              private authService: AuthService,
              private router : Router) { }

  ngOnInit(): void {
    this.initForm();
  }

  initForm(){
    this.signInForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.pattern(/[0-9a-zA-Z]{6,}/)]]
    });
  }

  async onSubmit(){
    const email = this.signInForm.get('email').value;
    const password = this.signInForm.get('password').value;
    this.authService.signInUser(email,password).then(
      ()=>{
        var id = firebase.auth().currentUser.uid;
        var ref = firebase.database().ref("users");
        ref.orderByKey().equalTo(id).on("child_added", (snapshot) => {
          
          if(snapshot.val().actif == false){
            this.errorMessage = "Compte désactivé"
          }
          else{
            this.router.navigate(['/home'])
          }
        });
        },
      (error)=>{
        this.errorMessage = error;
      }
    )
    

  }

  onNewPassword(){
    this.captcha = true
  }

  resolved(captchaResponse: string) {
    const email = this.signInForm.get('email').value;
    this.authService.resetPasswordInit(email).then(
      ()=>{
        this.errorMessage = "Mail de réinitialisation envoyé à "+email;
      },
      (error)=>{
        this.errorMessage = error;
      }
    );
  }
}
